import { ADSChangeEvent, Radio, RadioGroup } from '@appliedsystems/applied-design-system';
import { PadAgreementServiceType } from '@appliedsystems/payments-core';
import React from 'react';
import { usePaymentsTranslation } from '../../hooks/usePaymentsTranslation';

export const PadAgreementServiceTypeRadio = ({
  padAgreementServiceType,
  setPadAgreementServiceType,
}: {
  padAgreementServiceType: PadAgreementServiceType | undefined;
  setPadAgreementServiceType: (value: PadAgreementServiceType) => void;
}) => {
  const { t } = usePaymentsTranslation();

  return (
    <RadioGroup
      id="pad-agreement-service-type"
      label={t('PAD_AGREEMENT_SERVICE_TYPE_LABEL')}
      value={padAgreementServiceType}
      onChange={(e: ADSChangeEvent) => {
        setPadAgreementServiceType(e.target.value);
      }}
      className="my-50"
    >
      <Radio value={PadAgreementServiceType.Personal}>{t('PAD_AGREEMENT_PERSONAL')}</Radio>
      <Radio value={PadAgreementServiceType.Commercial}>{t('PAD_AGREEMENT_COMMERCIAL')}</Radio>
    </RadioGroup>
  );
};
